import { backendPy } from "System/system";
import store from "System/reduxStore";



// -------------------------------------------------------
// -------------------------------------------------------
export const getCriteriaData = (cb) => async (dispatch) => {
  const { id, datapath } = store.getState().project;
  const result = await backendPy("criteria", "read", {
    projectid: id, datapath,
  });
  if(result.data) {
    dispatch({type: "SET_CRITERIA_DATA", criteria: result.data});
  }
  cb();
};